<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="780px"
    custom-class="carousel-pic-modal"
    append-to-body
    :close-on-click-modal="false"
  >
    <div slot="title" class="carousel-modal-title">
      <div class="title-left">
        <span class="title-text">{{ $tt("轮播图片") }}</span>
        <span class="title-sub">{{ $tt("已添加") }} {{ picturesData.length }}</span>
      </div>
    </div>
    <div class="carousel-modal-body">
      <div class="carousel-toolbar">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="toolClickHandler('add')">
          {{ $tt("添加图片") }}
        </el-button>
        <el-button size="small" icon="el-icon-top" :disabled="!checkedPictures.length" @click="toolClickHandler('up')">
          {{ $tt("上移") }}
        </el-button>
        <el-button size="small" icon="el-icon-bottom" :disabled="!checkedPictures.length" @click="toolClickHandler('down')">
          {{ $tt("下移") }}
        </el-button>
        <el-button size="small" type="danger" plain icon="el-icon-delete" :disabled="!checkedPictures.length" @click="toolClickHandler('delete')">
          {{ $tt("删除") }}
        </el-button>
        <div class="toolbar-right">
          <el-checkbox
            v-if="picturesData.length"
            v-model="isAllChecked"
            @change="allCheckedChange"
          >
            {{ $tt("全选") }}
          </el-checkbox>
          <span v-if="checkedPictures.length" class="selected-hint">
            {{ $tt("已选") }} {{ checkedPictures.length }}
          </span>
        </div>
      </div>
      <div v-if="picturesData.length" class="carousel-grid">
        <div
          v-for="(p, index) in picturesData"
          :key="p.id || index"
          :class="['carousel-card', isActive(p.id) && 'is-active']"
          @click="clickHandler(p)"
        >
          <div class="card-thumb">
            <img :src="picUrl(p)" alt="" />
            <span class="card-index">{{ index + 1 }}</span>
            <span v-if="isActive(p.id)" class="card-check">
              <i class="el-icon-check" />
            </span>
          </div>
          <div class="card-name" :title="picName(p)">{{ picName(p) }}</div>
        </div>
      </div>
      <div v-else class="carousel-empty" @click="toolClickHandler('add')">
        <i class="el-icon-picture-outline" />
        <p>{{ $tt("还没有轮播图片") }}</p>
        <el-button type="primary" size="small" icon="el-icon-plus">{{ $tt("添加图片") }}</el-button>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible = false">{{ $tt("取 消") }}</el-button>
      <el-button size="small" type="primary" @click="confirmToChange()">{{ $tt("保 存") }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
export default {
  data() {
    return {
      dialogVisible: false,
      isAllChecked: false,
      checkedPictures: [],
      picturesData: [],
    };
  },
  props: {
    showImagesResourceModal: Function,
  },
  computed: mapState(["curComponent", "componentData"]),
  methods: {
    picUrl(p) {
      if (!p) {
        return "";
      }
      return p.file_down_path || p.fileDownPath || p.url || "";
    },
    picName(p) {
      if (!p) {
        return "未命名";
      }
      return p.file_real_name || p.file_name || p.name || "未命名";
    },
    allCheckedChange(v) {
      this.checkedPictures = v ? this.picturesData.slice() : [];
    },
    toolClickHandler(key) {
      if (key == "add") {
        this.showImagesResourceModal("carouselPics");
      } else if (key == "delete") {
        this.picturesData = this.picturesData.filter(
          (n) => this.checkedPictures.findIndex((o) => o.id == n.id) === -1
        );
        this.checkedPictures = [];
        this.isAllChecked = false;
      } else if (key == "up" || key == "down") {
        let arr = _.cloneDeep(this.picturesData);
        const checkedIndexArr = this.checkedPictures
          .reduce((res, item) => {
            res.push(arr.findIndex((i) => i.id == item.id));
            return res;
          }, [])
          .filter((i) => i >= 0)
          .sort((a, b) => a - b);
        if (!checkedIndexArr.length) {
          return;
        }
        const selected = checkedIndexArr.map((i) => arr[i]);
        arr = arr.filter(
          (n) => this.checkedPictures.findIndex((o) => o.id == n.id) === -1
        );
        let position = checkedIndexArr[0];
        if (key == "up") {
          position = Math.max(0, checkedIndexArr[0] - 1);
        } else {
          if (checkedIndexArr[0] + 1 >= this.picturesData.length) {
            return;
          }
          position = checkedIndexArr[0] + 1;
        }
        arr.splice(position, 0, ...selected);
        this.picturesData = arr;
      }
    },
    setCarouselPics(v) {
      const list = Array.isArray(v) ? v : v ? [v] : [];
      this.picturesData = _.uniqBy([...this.picturesData, ...list], "id");
    },
    initCheckedPictures() {
      const { carouselPics } = this.curComponent.style;
      this.picturesData = JSON.parse(JSON.stringify(carouselPics || []));
      this.checkedPictures = [];
      this.isAllChecked = false;
    },
    clickHandler(p) {
      const ind = _.findIndex(this.checkedPictures, { id: p.id });
      if (ind > -1) {
        this.checkedPictures.splice(ind, 1);
        this.isAllChecked = false;
        return;
      }
      this.checkedPictures = _.uniqBy([p, ...this.checkedPictures], "id");
      this.isAllChecked =
        this.checkedPictures.length == this.picturesData.length;
    },
    isActive(id) {
      return this.checkedPictures.findIndex((i) => i.id == id) > -1;
    },
    confirmToChange(e, isClear) {
      const all = this.componentData;
      const index = this.componentData.findIndex(
        (i) => i.id == this.curComponent.id
      );
      const pictures = JSON.parse(JSON.stringify(this.picturesData)).reduce(
        (arr, item) => {
          arr.push({
            id: item.id,
            file_down_path: this.picUrl(item),
            file_real_name: item.file_real_name,
            file_md5: item.file_md5,
            file_name: item.file_name || item.file_real_name || item.name,
          });
          return arr;
        },
        []
      );
      const obj = {
        ...this.curComponent,
        style: {
          ...this.curComponent.style,
          carouselPics: isClear ? [] : pictures,
        },
      };
      if (index !== -1) {
        all.splice(index, 1, obj);
        this.$store.commit("setComponentData", all);
      }
      this.$store.commit("setCurComponent", {
        component: obj,
        index: index !== -1 ? index : undefined,
      });
      this.$store.commit("recordSnapshot");
      this.dialogVisible = false;
    },
    switchDialogVisible(bol) {
      this.dialogVisible = bol;
    },
  },
};
</script>

<style lang="scss">
.carousel-pic-modal {
  border-radius: 8px;
  overflow: hidden;
  .el-dialog__header {
    padding: 14px 20px;
    background: #fff;
    border-bottom: 1px solid #ebeef5;
  }
  .el-dialog__body {
    padding: 16px 20px 8px;
  }
  .el-dialog__footer {
    padding: 12px 20px 16px;
    border-top: 1px solid #ebeef5;
  }
}
.carousel-modal-title {
  display: flex;
  align-items: center;
  .title-left {
    display: flex;
    align-items: baseline;
    gap: 10px;
  }
  .title-text {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }
  .title-sub {
    font-size: 13px;
    color: #909399;
    font-weight: 400;
  }
}
.carousel-modal-body {
  min-height: 360px;
}
.carousel-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  .toolbar-right {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .selected-hint {
    font-size: 13px;
    color: #409eff;
  }
}
.carousel-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  max-height: 420px;
  overflow: auto;
  padding: 2px;
}
.carousel-card {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background: #fff;
  transition: border-color 0.15s, box-shadow 0.15s;
  &:hover {
    border-color: #c0c4cc;
  }
  &.is-active {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }
  .card-thumb {
    position: relative;
    height: 110px;
    background: #f5f7fa;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  .card-index {
    position: absolute;
    left: 0;
    top: 0;
    min-width: 22px;
    height: 20px;
    padding: 0 6px;
    background: rgba(0, 0, 0, 0.55);
    color: #fff;
    font-size: 12px;
    line-height: 20px;
    border-bottom-right-radius: 6px;
  }
  .card-check {
    position: absolute;
    right: 6px;
    top: 6px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #409eff;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
  }
  .card-name {
    padding: 8px 10px;
    font-size: 12px;
    color: #606266;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.carousel-empty {
  height: 320px;
  border: 1px dashed #dcdfe6;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  cursor: pointer;
  background: #fafafa;
  &:hover {
    border-color: #409eff;
    color: #409eff;
    background: #f5faff;
  }
  i {
    font-size: 48px;
    margin-bottom: 8px;
  }
  p {
    margin: 0 0 12px;
    font-size: 14px;
  }
}
</style>
